import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { IContentSearchQuery } from '~/hooks/useContentSearch';

import { getQueryParams } from './SearchContent.util';

export function useSearchContentParams() {
  const router = useRouter();

  const {
    creator,
    page,
    platform,
    channel,
    query: search,
    roster,
    sortBy,
    ads,
    postedAfter,
    postedBefore,
    view,
  } = getQueryParams(router.query);

  return useMemo(() => {
    const params: IContentSearchQuery = {};

    if (platform && typeof platform === 'string') {
      Object.assign(params, { platform: [platform] });
    }

    if (channel && typeof channel === 'string') {
      Object.assign(params, { channel: [channel] });
    }

    if (ads) {
      Object.assign(params, {
        ads: ads === 'false' ? false : true,
      });
    }

    return {
      creator,
      ads,
      page,
      platform,
      channel,
      query: search,
      roster,
      sortBy,
      postedAfter,
      postedBefore,
      view,
      ...params,
    } as IContentSearchQuery;
  }, [
    creator,
    ads,
    page,
    platform,
    channel,
    search,
    roster,
    sortBy,
    postedAfter,
    postedBefore,
    view,
  ]);
}
